import styles from './ParamsTable.module.css';

interface TableSkeletonProps {
	rows: number;
	cols: number;
}

export const TableSkeleton = ({ rows, cols }: TableSkeletonProps) => (
	<table className={styles.table}>
		<thead className={styles.thead}>
			<tr>
				{Array.from({ length: cols }).map((_, i) => (
					<th key={i}>
						<div className={styles.skeleton} style={{ width: '4rem' }} />
					</th>
				))}
			</tr>
		</thead>
		<tbody className={styles.tbody}>
			{Array.from({ length: rows }).map((_, r) => (
				<tr key={r}>
					{Array.from({ length: cols }).map((_, c) => (
						<td key={c}>
							<div className={styles.skeleton} style={{ width: c === 0 ? '8rem' : '4rem' }} />
						</td>
					))}
				</tr>
			))}
		</tbody>
	</table>
);
